import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { LIST_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Container: styled.ul`
    ${LIST_RESET}

    display: flex;
    flex-direction: column;
    gap: ${SPACING.size16};
    padding-left: 0;
  `,

  Item: styled.li`
    ${TYPOGRAPHY.bodySmallMediumTabular}
    color: ${COLORS['pebble-500']};
    position: relative;
    padding-left: ${SPACING.size24};
    display: flex;
    align-items: flex-start;

    &::before {
      content: '';
      position: absolute;
      left: 8px;
      top: 10px;
      min-width: 4px;
      min-height: 4px;
      width: 4px;
      height: 4px;
      background-color: ${COLORS['charcoal-500']};
      border-radius: 50%;
      transform: translateY(-50%);
    }
  `
};
